export default `---
foo: bar
---
#Question #Q #Q1 
  What is your name?

#Answer #A 
  My name is [Jack]{PER}
`
